import { Component, Input } from '@angular/core';
import { LocaleContextService } from '../../services/locale-context.service';
import { ROUTES_MAP } from '../../routes.map';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../../core/components/base/base.service';
import { IContentLang } from '../../shared.definitions';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent {
  @Input() isFooter: boolean;
  isDropdownOpen = false;

  get languages$(): Observable<Array<IContentLang>> {
    return this.baseService.languages$;
  }

  get currentLanguage$(): Observable<IContentLang> {
    return this.baseService.currentLanguage$;
  }

  get isMobileMenuOpen$(): Observable<boolean> {
    return this.baseService.isMobileMenuOpen$;
  }

  constructor(
    private readonly localizeService: LocalizeRouterService,
    private readonly baseService: BaseService,
    private readonly router: Router,
    private readonly localeContextService: LocaleContextService,
    private readonly translateService: TranslateService,
  ) {}

  navigateToHungarianSiteWithSlugs(): void {
    const currentPath = this.router.url.split('?')[0].split('#')[0];
    const pathParts = currentPath.split('/').filter(Boolean);
    let subUrl = '';

    // Detect if first part is a language code (2 letters)
    let startIdx = 0;
    if (pathParts[0] && pathParts[0].length === 2) {
      startIdx = 1;
    }

    if (pathParts.length - startIdx === 1) {
      // /slug or /language/slug
    } else if (pathParts.length - startIdx >= 2) {
      // /subUrl/slug or /language/subUrl/slug
      subUrl = pathParts[startIdx];
    } else {
      window.location.href = environment.csodasDomain ?? '';
      return;
    }

    let huSubUrl = subUrl;
    if (subUrl) {
      const pageType = this.localeContextService.currentPageType$.getValue();
      let routeKey = '';
      const routesMapAny = ROUTES_MAP as Record<string, any>;
      if (pageType && routesMapAny[pageType]) {
        const mapVal = routesMapAny[pageType];
        routeKey = Array.isArray(mapVal) ? mapVal[0] : mapVal;
      } else {
        routeKey = subUrl;
      }

      const huTranslations = this.translateService.store.translations['hu'];
      if (huTranslations && huTranslations[`ROUTES.${routeKey}`]) {
        huSubUrl = huTranslations[`ROUTES.${routeKey}`];
      } else {
        huSubUrl = subUrl;
      }
    }

    let huSlug = '';
    const slugsObj = (this.localeContextService.currentLocalizedSlugs$.getValue() as { [key: string]: string });
    if (slugsObj && typeof slugsObj === 'object') {
      huSlug = slugsObj['hu'];
    }

    if (!huSlug) {
      window.location.href = environment.csodasDomain ?? '';
      return;
    }

    let base = environment.csodasDomain;
    if (base?.endsWith('/')) base = base.slice(0, -1);
    let newUrl = '';
    if (huSubUrl) {
      newUrl = `${base}/${huSubUrl}/${huSlug}`;
    } else {
      newUrl = `${base}/${huSlug}`;
    }
    window.location.href = newUrl;
  }

  toggleDropdown(val?: boolean): void {
    this.isDropdownOpen = val ?? !this.isDropdownOpen;
  }

  async changeLanguage(language: IContentLang): Promise<void> {
    this.toggleDropdown();
    if (this.baseService.isMobileMenuOpen()) {
      this.baseService.toggleMobileMenu();
    }
    this.localizeService.changeLanguage(language.locale);
  }
}
